export const languages = [
  { command: 'hy', local: 'Հայերեն(AM-hy)' }, // 亚美尼亚语
  { command: 'ar', local: '(SA-ar)Български' }, // 阿拉伯语
  { command: 'bg', local: 'Hrvatski(BG-bu)' }, // 保加利亚语
  { command: 'zh', local: '简体中文(CN-zh)' }, // 简体中文
  { command: 'hr', local: 'Hrvatski(HR-hr)' }, // 克罗地亚语
  { command: 'cs', local: 'Čeština(CZ-cs)' }, // 捷克语
  { command: 'en', local: 'English(GB-en)' }, // 英语
  { command: 'fr', local: 'Français(FR-fr)' }, // 法语
  { command: 'hu', local: 'Magyar(HU-hu)' }, // 匈牙利语
  //   { command: 'it', local: 'Italiano(it)' },// 意大利语
  { command: 'mk', local: 'Македонски(MK-mk)' }, // 马其顿语
  { command: 'pt', local: 'Português(PT-po)' }, // 葡萄牙语
  { command: 'sr', local: 'Srpski(RS-sr)' }, // 塞尔维亚语
  { command: 'sk', local: 'Slovenčina(SK-sl)' }, // 斯洛伐克语
  { command: 'sl', local: 'Slovenščina(SI-sl)' }, // 斯洛文尼亚语
  { command: 'tr', local: 'Türkiye(TR-tu)' } // 土耳其语
];

export function langStr(langCode) {
  const lang = languages.find((item) => item.command === langCode);
  return lang ? lang.local : '简体中文(zh_CN)';
}
